import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import { Button, CircularProgress, Grid } from '@mui/material';
import { TextField } from 'formik-mui';
import ArrowRight from '../../shared/components/icons/ArrowRight';
import { FormProps } from '../AuthLayout';
import styles from '../auth.module.scss';
import axios from 'axios';

export default function SetPasswordForm({ setSuccess, setError }: FormProps) {
  const { uid, token } = useParams<{ uid: string; token: string }>();

  const navigate = useNavigate();

  const requiredMsg = 'This field cannot be empty.';
  const validationSchema = Yup.object({
    newPassword: Yup.string().required(requiredMsg),
    reNewPassword: Yup.string()
      .oneOf([Yup.ref('newPassword')], 'Passwords are not the same.')
      .required(requiredMsg),
  });

  return (
    <Formik
      initialValues={{
        newPassword: '',
        reNewPassword: '',
      }}
      validationSchema={validationSchema}
      onSubmit={async (values) => {
        setError(false);
        return axios
          .post('/api/auth/setup_initial_password/', { uid, token, ...values })
          .then(() => {
            setSuccess(true);
            navigate('/login');
          })
          .catch((e) => {
            console.error(e);
            setError(true);
          });
      }}
    >
      {({ isSubmitting }) => (
        <Form className={styles.form}>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Field component={TextField} type="password" label="Password" name="newPassword" fullWidth />
            </Grid>
            <Grid item xs={12}>
              <Field component={TextField} type="password" label="Repeat Password" name="reNewPassword" fullWidth />
            </Grid>
            <Grid item xs={12}>
              <Button type="submit" size="large" variant="outlined" fullWidth endIcon={!isSubmitting && <ArrowRight />}>
                {isSubmitting ? <CircularProgress color="primary" size={24} /> : 'Set password'}
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}
